/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import cx from 'classnames';

class SavingsBifurcation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }

  togglePanel = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { savingsBifurcationData } = this.props;

    return (
      <div className="SavingsBifurcation">
        <div className="titleContainer" onClick={this.togglePanel}>
          <img
            src="https://assets.pharmeasy.in/web-assets/images/icRupee.svg"
            alt=""
            width={24}
            height={24}
          />
          <div dangerouslySetInnerHTML={{ __html: savingsBifurcationData.title }} />
          <span
            className={cx({
              open: this.state.isOpen
            })}
          >
            <img
              src="https://assets.pharmeasy.in/web-assets/images/chevron-down.svg"
              width={24}
              height={24}
              alt="down"
            />
          </span>
        </div>
        {this.state.isOpen && savingsBifurcationData.list.map(el => (
          <div key={el.name}>
            <div className="keyContainer">
              <div dangerouslySetInnerHTML={{ __html: el.name }} />
              <div>
                {el.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default SavingsBifurcation;
